import { createRouter, createWebHistory } from 'vue-router'
import { useUserStoreWithOut } from '@/store/modules/user'
import { NO_REDIRECT_WHITE_LIST } from '@/constants'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      redirect: '/login',
    },
    // ---- 无需布局的认证页面 ----
    {
      path: '/login',
      name: 'login',
      component: () => import('@/modules/auth/pages/LoginPage.vue'),
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/modules/auth/pages/RegisterPage.vue'),
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: () => import('@/modules/auth/pages/ForgotPasswordPage.vue'),
    },
    // ---- 不需要侧边栏的页面 ----
    {
      path: '/storyboard',
      name: 'storyboard',
      meta: { requiresAuth: true },
      component: () => import('@/modules/storyboard/pages/StoryboardPage.vue'),
    },
    // ---- AppLayout 包裹的页面 ----
    {
      path: '/',
      component: () => import('@/shared/layout/AppLayout.vue'),
      meta: { requiresAuth: true },
      children: [
        {
          path: 'workbench',
          name: 'workbench',
          component: () => import('@/modules/workbench/pages/WorkbenchPage.vue'),
        },
        {
          path: 'project/:id',
          name: 'project-detail',
          component: () => import('@/modules/project/pages/ProjectDetailPage.vue'),
        },
        {
          path: 'asset',
          name: 'assets',
          component: () => import('@/modules/assets/pages/AssetsPage.vue'),
        },
        {
          path: 'asset/:type',
          name: 'asset-category',
          component: () => import('@/modules/assets/pages/AssetCategoryPage.vue'),
        },
        {
          path: 'asset/',
          redirect: { name: 'assets' },
        },
        {
          path: 'team',
          name: 'team',
          component: () => import('@/modules/team/pages/TeamManagementPage.vue'),
        },
        {
          path: 'invoice',
          name: 'invoice',
          component: () => import('@/modules/finance/pages/InvoicePage.vue'),
        },
        {
          path: 'purchase',
          name: 'purchase',
          component: () => import('@/modules/finance/pages/PurchaseCoinsPage.vue'),
        },
        {
          path: 'transactions',
          name: 'transactions',
          component: () => import('@/modules/finance/pages/TransactionHistoryPage.vue'),
        },
        {
          path: 'recharges',
          name: 'recharges',
          component: () => import('@/modules/finance/pages/RechargeHistoryPage.vue'),
        },
        {
          path: 'profile',
          name: 'profile',
          component: () => import('@/modules/user/pages/ProfilePage.vue'),
        },
        {
          path: 'change-password',
          name: 'change-password',
          component: () => import('@/modules/auth/pages/ChangePasswordPage.vue'),
        },
        {
          path: 'messages',
          name: 'messages',
          component: () => import('@/modules/user/pages/MessagesPage.vue'),
        },
      ],
    },
  ],
})

// 无需登录即可访问的白名单
const whiteList = NO_REDIRECT_WHITE_LIST

router.beforeEach((to) => {
  const userStore = useUserStoreWithOut()
  const token = userStore.getToken

  if (token) {
    // 已登录
    if (to.path === '/login') {
      // 已登录访问登录页 → 跳到工作台
      return '/workbench'
    }
    return
  }

  // 未登录
  if (whiteList.includes(to.path)) {
    return
  }
  // 其他页面 → 跳转登录页，携带 redirect 参数
  return `/login?redirect=${encodeURIComponent(to.fullPath)}`
})

export default router
